import React from 'react';
import { useAppSelector } from "../../../../hooks/useAppSelector";
import {useAppDispatch} from "../../../../hooks/useAppDispatch";
import {getStageKey, updateFeatureAttributes} from "../../../../services/reducers/utilities-journal";
import {clearSelectedGraphic} from "../../../../services/actions/map";
import {Roles} from "../../../../types/roles";
import EditAttributesModalView from "../../../../shared/edit-attributes-modal-view/edit-attributes-modal-view";

const EditAttributesModal = () => {
    const {selectedFeature, selectedRow} = useAppSelector(state => state.masterUtilities);
    const userRoles = useAppSelector(state => state.user.user?.roles)
    const {drawingToolsIsActive} = useAppSelector(state => state.map)
    const attributes = selectedFeature?.attributes ?? {};
    const layerName = selectedFeature?.layerName ?? '';
    const dispatch = useAppDispatch();

    if (!selectedFeature) return null;

    const isApprovedAsBuilt = selectedRow?.stage === 'As-Built' && selectedRow.status === 'Approved'
    const currentStage = selectedRow ? getStageKey(selectedRow.stage) : null;

    const userCanEditAttributes= Boolean(
        drawingToolsIsActive &&
        (userRoles?.includes(Roles.Contractor) ||
            userRoles?.includes(Roles.DepartmentSpecialist)) &&
        !isApprovedAsBuilt &&
        currentStage === selectedFeature?.stage
    )

    const handleSave = (newAttributes: Record<string, string>) => {
        dispatch(updateFeatureAttributes({
            layerName: layerName,
            objectId: attributes.uuid,
            newAttributes,
            stage: selectedFeature.stage
        }));
    };

    return (
        <EditAttributesModalView
            layerName={layerName}
            attributes={attributes}
            onSave={handleSave}
            onCancel={() => dispatch(clearSelectedGraphic())}
            userCanEditAttributes={userCanEditAttributes}
        />
    );
};

export default EditAttributesModal;
